<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="fm/factory-manger"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="工厂编码">
            <el-input v-model.trim="filter.factoryCode" placeholder="请输入工厂编码" clearable />
          </el-form-item>
          <el-form-item label="工厂全称">
            <el-input v-model.trim="filter.factoryName" placeholder="请输入工厂全称" clearable />
          </el-form-item>
          <el-form-item label="工厂简称">
            <el-input v-model.trim="filter.factoryShortName" placeholder="请输入工厂简称" clearable />
          </el-form-item>
          <el-form-item label="工厂类型">
            <el-select v-model="filter.factoryType" placeholder="请选择工厂类型" clearable>
              <el-option v-for="item in factoryTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="工厂状态">
            <el-select v-model="filter.factoryStatus" placeholder="请选择工厂状态" clearable>
              <el-option v-for="item in factoryStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="省份">
            <el-input v-model.trim="filter.province" placeholder="请输入省份" clearable />
          </el-form-item>
          <el-form-item label="城市">
            <el-input v-model.trim="filter.city" placeholder="请输入城市" clearable />
          </el-form-item>
          <el-form-item label="厂长">
            <el-input v-model.trim="filter.factoryDirector" placeholder="请输入厂长姓名" clearable />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <FactoryEdit ref="factoryEdit" @save-success="loadData" />
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import FactoryEdit from "./FactoryEdit";

export default {
  components: { viewTable, FactoryEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(146),
        editAuth: this.$auth(147),
        delAuth: this.$auth(148),
      },
      factoryTypeOptions: [
        { label: "自有生产厂", value: 1 },
        { label: "委外代工厂", value: 2 },
        { label: "仓储中转基地", value: 3 },
        { label: "研发试制基地", value: 4 },
      ],
      factoryStatusOptions: [
        { label: "筹建", value: 0 },
        { label: "正常生产", value: 1 },
        { label: "临时停产", value: 2 },
        { label: "永久关停", value: 3 },
      ],
      filter: {
        factoryCode: "",
        factoryName: "",
        factoryShortName: "",
        factoryType: null,
        factoryStatus: null,
        province: "",
        city: "",
        factoryDirector: "",
      },
      columnsProperty: [
        { tooltip: true, key: "factoryCode", width: 130, align: "center" },
        { tooltip: true, key: "factoryName", minWidth: 180 },
        { tooltip: true, key: "factoryShortName", width: 120 },
        { tooltip: true, key: "factoryTypeName", width: 120, align: "center" },
        { tooltip: true, key: "factoryStatusName", width: 100, align: "center" },
        { tooltip: true, key: "province", width: 90, align: "center" },
        { tooltip: true, key: "city", width: 90, align: "center" },
        { tooltip: true, key: "factoryDirector", width: 100 },
        { tooltip: true, key: "standardYearCapacity", width: 120, align: "right" },
        { key: "action", align: "center", width: 100, slot: "action" },
      ],
    };
  },
  methods: {
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },
    addEditHandle(row) {
      this.$refs.factoryEdit.open(row);
    },
    deleteHandle(row) {
      this.$http.delete("basic", "fm/factory-manger", row.id).then((resp) => {
        if (resp.success) {
          this.$message.success("删除成功");
          this.loadData();
        }
      });
    },
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
